(() => {
  const initStickyAddToCart = (bar) => {
    if (!bar || bar.dataset.lnduStickyReady === 'true') return;

    bar.dataset.lnduStickyReady = 'true';
    const showAfter = Number.parseInt(bar.dataset.showAfter, 10) || 360;

    const update = () => {
      bar.classList.toggle('is-visible', window.scrollY > showAfter);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  };

  const initAll = () => {
    document.querySelectorAll('[data-lndu-sticky-add-to-cart]').forEach(initStickyAddToCart);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
